import axios from "axios";
import Swal from "sweetalert2";
import { tokenConfig } from "./websiteActions";
import { t } from "i18next";
import { omitBy } from "lodash";

export const getProducts =
    (params = {}) =>
    (dispatch, getState) => {
        const p = omitBy(params, (value) => !Boolean(value));
        const paramsUrl = new URLSearchParams(p).toString();
        return axios
            .get(`/api/spy-advanced?${paramsUrl}`, tokenConfig(getState))
            .then((res) => {
                if (res.data.status === 200) {
                    return res.data.data;
                } else {
                    Swal.fire(t("Error"), t(res.data.message), "error");
                }
            })
            .catch((err) => {
                Swal.fire(t("Error"), t("An error occurred!"), "error");
            });
    };

export const getLeaderboard =
    (params = {}) =>
    (dispatch, getState) => {
        const p = omitBy(params, (value) => !Boolean(value));
        const paramsUrl = new URLSearchParams(p).toString();
        return axios
            .get(`/api/spy-advanced/leaderboard?${paramsUrl}`, tokenConfig(getState))
            .then((res) => {
                if (res.data.status === 200) {
                    return res.data.data;
                } else {
                    Swal.fire(t("Error"), t(res.data.message), "error");
                }
            })
            .catch((err) => {
                Swal.fire(t("Error"), t("An error occurred!"), "error");
            });
    };

export const addSystems = (body) => (dispatch, getState) => {
    return axios
        .post(`/api/spy-advanced`, body, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                Swal.fire(t("Success"), t(res.data.message), "success");
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const getProductTrend = (ids) => (dispatch, getState) => {
    if (!ids) return;

    return axios
        .get(`/api/spy-advanced/product-trend?ids=${ids}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const getProductAnalysis = (params) => (dispatch, getState) => {
    if (!params.id) return;

    const p = omitBy(params, (value) => !Boolean(value));
    const paramsUrl = new URLSearchParams(p).toString();

    return axios
        .get(`/api/spy-advanced/product-analysis?${paramsUrl}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const getProductDetail = (id) => (dispatch, getState) => {
    if (!id) return;

    return axios
        .get(`/api/spy-advanced/product-detail/${id}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const getProductDetailInfluencer = ({ productId, ...params}) => (dispatch, getState) => {
    if (!productId) return;
    const p = omitBy(params, (value) => !Boolean(value));
    const paramsUrl = new URLSearchParams(p).toString();
    return axios
        .get(`/api/spy-advanced/product-detail/${productId}/influencers?${paramsUrl}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const getProductDetailVideo = ({ productId, ...params}) => (dispatch, getState) => {
    if (!productId) return;
    const p = omitBy(params, (value) => !Boolean(value));
    const paramsUrl = new URLSearchParams(p).toString();
    return axios
        .get(`/api/spy-advanced/product-detail/${productId}/video?${paramsUrl}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const getProductDetailLive = ({ productId, ...params}) => (dispatch, getState) => {
    if (!productId) return;
    const p = omitBy(params, (value) => !Boolean(value));
    const paramsUrl = new URLSearchParams(p).toString();
    return axios
        .get(`/api/spy-advanced/product-detail/${productId}/live?${paramsUrl}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const getShops =
    (params = {}) =>
    (dispatch, getState) => {
        const p = omitBy(params, (value) => !Boolean(value));
        const paramsUrl = new URLSearchParams(p).toString();
        return axios
            .get(`/api/spy-advanced/shops?${paramsUrl}`, tokenConfig(getState))
            .then((res) => {
                if (res.data.status === 200) {
                    return res.data.data;
                } else {
                    Swal.fire(t("Error"), t(res.data.message), "error");
                }
            })
            .catch((err) => {
                Swal.fire(t("Error"), t("An error occurred!"), "error");
            });
    };

export const getShopTrend = (ids) => (dispatch, getState) => {
    if (!ids) return;

    return axios
        .get(`/api/spy-advanced/shop-trend?ids=${ids}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const getShopDetail = (params = {}) => (dispatch, getState) => {
    const { seller_id } = params;
    if (!seller_id) return;

    delete params?.seller_id;

    const p = omitBy(params, (value) => !Boolean(value));
    const paramsUrl = new URLSearchParams(p).toString();

    return axios
        .get(`/api/spy-advanced/shop-detail/${seller_id}?${paramsUrl}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const getProductsByShop = (params = {}) => (dispatch, getState) => {
    const { seller_id } = params;
    if (!seller_id) return;

    delete params?.seller_id;

    const p = omitBy(params, (value) => !Boolean(value));
    const paramsUrl = new URLSearchParams(p).toString();

    return axios
        .get(`/api/spy-advanced/products-by-shop/${seller_id}?${paramsUrl}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const getInfluencersByShop = (params = {}) => (dispatch, getState) => {
    const { seller_id } = params;
    if (!seller_id) return;

    delete params?.seller_id;

    const p = omitBy(params, (value) => !Boolean(value));
    const paramsUrl = new URLSearchParams(p).toString();

    return axios
        .get(`/api/spy-advanced/influencers-by-shop/${seller_id}?${paramsUrl}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const getVideosByShop = (params = {}) => (dispatch, getState) => {
    const { seller_id } = params;
    if (!seller_id) return;

    delete params?.seller_id;

    const p = omitBy(params, (value) => !Boolean(value));
    const paramsUrl = new URLSearchParams(p).toString();

    return axios
        .get(`/api/spy-advanced/videos-by-shop/${seller_id}?${paramsUrl}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const getInfluencersFilters =
    () =>
    (dispatch, getState) => {
        return axios
            .get(`/api/spy-advanced/influencers-filters`, tokenConfig(getState))
            .then((res) => {
                if (res.data.status === 200) {
                    return res.data.data;
                } else {
                    Swal.fire(t("Error"), t(res.data.message), "error");
                }
            })
            .catch((err) => {
                Swal.fire(t("Error"), t("An error occurred!"), "error");
            });
    };

export const getInfluencers =
    (params = {}) =>
    (dispatch, getState) => {
        const p = omitBy(params, (value) => !Boolean(value));
        const paramsUrl = new URLSearchParams(p).toString();
        return axios
            .get(`/api/spy-advanced/influencers?${paramsUrl}`, tokenConfig(getState))
            .then((res) => {
                if (res.data.status === 200) {
                    return res.data.data;
                } else {
                    Swal.fire(t("Error"), t(res.data.message), "error");
                }
            })
            .catch((err) => {
                Swal.fire(t("Error"), t("An error occurred!"), "error");
            });
    };


export const getInfluencerDetail = (params = {}) => (dispatch, getState) => {
    const { influencer_id } = params;
    if (!influencer_id) return;

    delete params?.influencer_id;

    const p = omitBy(params, (value) => !Boolean(value));
    const paramsUrl = new URLSearchParams(p).toString();

    return axios
        .get(`/api/spy-advanced/influencer-detail/${influencer_id}?${paramsUrl}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const getProductsByInfluencer = (params = {}) => (dispatch, getState) => {
    const { influencer_id } = params;
    if (!influencer_id) return;

    delete params?.influencer_id;

    const p = omitBy(params, (value) => !Boolean(value));
    const paramsUrl = new URLSearchParams(p).toString();

    return axios
        .get(`/api/spy-advanced/products-by-influencer/${influencer_id}?${paramsUrl}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const getVideo =
    (params = {}) =>
    (dispatch, getState) => {
        const p = omitBy(params, (value) => !Boolean(value));
        const paramsUrl = new URLSearchParams(p).toString();
        return axios
            .get(`/api/spy-advanced/video?${paramsUrl}`, tokenConfig(getState))
            .then((res) => {
                if (res.data.status === 200) {
                    return res.data.data;
                } else {
                    Swal.fire(t("Error"), t(res.data.message), "error");
                }
            })
            .catch((err) => {
                Swal.fire(t("Error"), t("An error occurred!"), "error");
            });
    };


export const getVideoDetail = (id) => (dispatch, getState) => {
    if (!id) return;

    return axios
        .get(`/api/spy-advanced/video/${id}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const getVideoAnalysis = (params) => (dispatch, getState) => {
    if (!params.id) return;
    const { id, ...other } = params;
    const p = omitBy(other, (value) => !Boolean(value));
    const paramsUrl = new URLSearchParams(p).toString();

    return axios
        .get(`/api/spy-advanced/video/${id}/analysis?${paramsUrl}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};